const settings = {
  posthog_key: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  posthog_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  api_host: import.meta.env.VITE_API_URL
};

const state_routes = {
  login: '/login',
};

export { settings, state_routes };
